import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { API_BASE } from '../api';
import "../css/styles.css";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE}/api/blogs/${id}`)
      .then(res => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then(data => {
        setBlog(data);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [id]);

  if (loading) return (
    <div className="blog-not-found">
      <h2>Loading...</h2>
    </div>
  );

  if (error || !blog) return (
    <div className="blog-not-found">
      <h2>Blog not found</h2>
      <Link to="/blogs" className="blog-back-link"><FaArrowLeft /> Back to Stories</Link>
    </div>
  );

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  // Parse images — split on "https://" to handle Cloudinary URLs with commas in params
  const parseImages = (imageStr) => {
    if (!imageStr) return [];
    return imageStr.split("https://").filter(Boolean).map(s => "https://" + s.replace(/,\s*$/, ""));
  };
  const images = parseImages(blog.image);
  const heroImage = images[activeImg] || images[0] || "";
  const heroStyle = heroImage
    ? { backgroundImage: `url(${heroImage})` }
    : { background: "linear-gradient(135deg, #1a3c34 0%, #2d6b4f 50%, #3a8c5c 100%)" };

  return (
    <div className="blog-detail-page">
      <div className="blog-detail-hero" style={heroStyle}>
        <div className="blog-detail-hero-overlay" />
        <div className="blog-detail-hero-content">
          <Link to="/blogs" className="blog-back-link"><FaArrowLeft /> Back to Stories</Link>
          <h1>{blog.title}</h1>
          <span className="blog-detail-meta"><FaCalendarAlt /> {formatDate(blog.created_at)}</span>
          {(blog.author_name || blog.author) && <span className="blog-detail-author">By {blog.author_name || blog.author}</span>}
        </div>
        {images.length > 1 && (
          <div className="blog-hero-nav">
            <button onClick={() => setActiveImg((activeImg - 1 + images.length) % images.length)}><FaChevronLeft /></button>
            <span>{activeImg + 1} / {images.length}</span>
            <button onClick={() => setActiveImg((activeImg + 1) % images.length)}><FaChevronRight /></button>
          </div>
        )}
      </div>

      {/* Image gallery thumbnails */}
      {images.length > 1 && (
        <div className="blog-gallery">
          {images.map((img, i) => (
            <button key={i} className={`blog-gallery-thumb ${i === activeImg ? "active" : ""}`} onClick={() => setActiveImg(i)}>
              <img src={img} alt={`Photo ${i + 1}`} />
            </button>
          ))}
        </div>
      )}

      <article className="blog-detail-body">
        {blog.content ? (
          <div className="blog-detail-content" dangerouslySetInnerHTML={{ __html: blog.content }} />
        ) : (
          <div className="blog-detail-content">{blog.description}</div>
        )}
      </article>
    </div>
  );
};

export default BlogDetail;

